import styled from 'styled-components';

const clsPrefix = 'list-item-right-data';

export const cssClasses = {
  wrapper: clsPrefix,
  left: `${clsPrefix}-left`,
  right: `${clsPrefix}-right`,
} as const;

export const ListItemRightDataSC = styled.div`
  display: flex;
  align-items: center;
  padding-right: 24px;

  .${cssClasses.left} {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
    margin-left: 12px;
  }

  .${cssClasses.right} {
    margin-left: 12px;
  }
`;
